import React, { useEffect } from 'react';

import LeavesForm from '../../components/employees/Leaves';



const  LeavesPage = () => {
   useEffect(() => {
        document.body.id = "leaves-004";
      }, []);
  return (
    <div className='commom-001'>
       <LeavesForm />
    </div>
  );
};

export default  LeavesPage;
